import { render, staticRenderFns } from "./createToken.vue?vue&type=template&id=1898e1de"
import script from "./createToken.vue?vue&type=script&lang=js"
export * from "./createToken.vue?vue&type=script&lang=js"
import style0 from "./createToken.vue?vue&type=style&index=0&id=1898e1de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports